import React, { useState } from "react";
import { api, rupiah } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Printer, Download, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export async function fetchReceiptBlob(txId) {
  const r = await api.get(`/admin/receipts/${txId}`, { responseType: "blob" });
  return URL.createObjectURL(r.data);
}

export async function printReceipt(txId) {
  const w = window.open("", "_blank");
  try {
    const url = await fetchReceiptBlob(txId);
    if (w) {
      w.location.href = url;
    } else {
      toast.error("Pop-up diblokir browser. Izinkan pop-up untuk mencetak kuitansi.");
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch {
    if (w) w.close();
    toast.error("Kuitansi tidak dapat dimuat");
  }
}

export async function downloadReceipt(txId) {
  try {
    const url = await fetchReceiptBlob(txId);
    const a = document.createElement("a");
    a.href = url; a.download = `kuitansi_${txId.slice(0, 8)}.pdf`; a.click();
    URL.revokeObjectURL(url);
  } catch {
    toast.error("Kuitansi tidak dapat dimuat");
  }
}

// receipt: { tx_id, title, student, jenis, amount, balance_after }
export const ReceiptDialog = ({ receipt, onClose }) => {
  const [busy, setBusy] = useState(false);
  const act = async (fn) => { setBusy(true); await fn(receipt.tx_id); setBusy(false); };
  return (
    <Dialog open={!!receipt} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="receipt-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2 text-emerald-700">
            <CheckCircle2 size={20} /> {receipt?.title}
          </DialogTitle>
        </DialogHeader>
        {receipt && (
          <div className="rounded-xl bg-stone-50 border p-4 text-sm space-y-1.5 mt-2">
            <div className="flex justify-between"><span className="text-stone-500">Santri</span><b data-testid="receipt-student">{receipt.student}</b></div>
            <div className="flex justify-between"><span className="text-stone-500">Jenis</span><b>{receipt.jenis}</b></div>
            <div className="flex justify-between"><span className="text-stone-500">Nominal</span><b className="font-mono text-emerald-700" data-testid="receipt-amount">{rupiah(receipt.amount)}</b></div>
            {receipt.balance_after != null && (
              <div className="flex justify-between"><span className="text-stone-500">Saldo akhir</span><b className="font-mono">{rupiah(receipt.balance_after)}</b></div>
            )}
          </div>
        )}
        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="outline" onClick={onClose} data-testid="receipt-close-button" className="rounded-xl">Tutup</Button>
          <Button variant="outline" disabled={busy} onClick={() => act(downloadReceipt)} data-testid="receipt-download-button" className="rounded-xl">
            <Download size={15} className="mr-1.5" /> Unduh PDF
          </Button>
          <Button disabled={busy} onClick={() => act(printReceipt)} data-testid="receipt-print-button" className="bg-emerald-600 hover:bg-emerald-700 rounded-xl">
            <Printer size={15} className="mr-1.5" /> Cetak Kuitansi
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
